export const DETAIL_MODES = {
    EDIT: 'EDIT',
    VIEW: 'VIEW',
    NEW: 'NEW',
};

export const SOCCER_AUTH_DEFS = [
    {
        label: 'Remote Events',
        auth: 'authRemoteEventTMCLs',
        siteLevelAuth: 'hasRemoteEventsData',
    },
    {
        label: 'Remote Fitness',
        auth: 'authRemoteFitnessTMCLs',
        siteLevelAuth: 'hasRemoteFitnessData',
    },
    {
        label: 'In-Venue Events',
        auth: 'authInVenueEventTMCLs',
        siteLevelAuth: 'hasInVenueEventsData',
    },
    {
        label: 'In-Venue Fitness',
        auth: 'authInVenueFitnessTMCLs',
        siteLevelAuth: 'hasInVenueFitnessData',
    },
];
export const RUGBY_AUTH_DEFS = [
    {
        label: 'hasExpectedOutcome',
        auth: 'expectedOutcomeComps',
    },
    {
        label: 'hasRawValue',
        auth: 'rawValueComps',
    },
];

export const RUGBY_CATEGORY_OPTIONS = {
    RUGBY_UNION: {
        name: 'RU',
        displayKey: 'Rugby Union',
    },
    RUGBY_LEAGUE: {
        name: 'RL',
        displayKey: 'Rugby League',
    },
};
